import api from '@pray/shared/utils/api';

type DeleteLeadsListProps = {
  artistId: string;
  listId: string;
};

export async function deleteLeadsList({ artistId, listId }: DeleteLeadsListProps) {
  const url = `/web/studio/artists/${artistId}/leads-lists/${listId}`;
  const response = await api.executeDeleteRequest<undefined>(url);

  return response.data;
}
